var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSexdrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "120px",
    viewBox: "0 0 121 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-side-effects",
    transform: "translate(-1221.000000, -380.000000)",
    strokeWidth: 4.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1220.000000, 382.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 0.057600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.62889,17.13354 C72.55779,17.13354 84.66009,28.67304 84.66009,42.90774 C84.66009,57.14214 72.55779,68.68164 57.62889,68.68164 C42.69969,68.68164 30.59739,57.14214 30.59739,42.90774 C30.59739,28.67304 42.69969,17.13354 57.62889,17.13354 Z",
    id: "Stroke-3",
    stroke: "#222456",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.78437,
    y1: 17.71569,
    x2: 17.47347,
    y2: 98.02659,
    id: "Stroke-5",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.25775,57.87117 C115.25775,89.69877 89.45655,115.49997 57.62895,115.49997 C25.80135,115.49997 0.00015,89.69877 0.00015,57.87117 C0.00015,26.04357 25.80135,0.24207 57.62895,0.24207 C89.45655,0.24207 115.25775,26.04357 115.25775,57.87117 Z",
    id: "Stroke-7",
    stroke: "#222456",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.53111,
    y1: 87.37251,
    x2: 70.77261,
    y2: 87.37251,
    id: "Stroke-1",
    stroke: "#222456",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.19005,
    y1: 71.36736,
    x2: 57.19005,
    y2: 98.60886,
    id: "Stroke-2",
    stroke: "#222456",
    strokeLinejoin: "round"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSexdrive);
export default __webpack_public_path__ + "static/media/sexdrive.b3bdab05.svg";
export { ForwardRef as ReactComponent };